module.exports = __webpack_public_path__ + "img/ac1.f52bc304.png";